import Armont101 from '../../../BSD/Armont/Tipe 10/Tipe 10 (1).webp'
import Armont102 from '../../../BSD/Armont/Tipe 10/Tipe 10 (2).webp'
import Armont103 from '../../../BSD/Armont/Tipe 10/Tipe 10 (3).webp'
import Armont104 from '../../../BSD/Armont/Tipe 10/Tipe 10 (4).webp'
import Armont105 from '../../../BSD/Armont/Tipe 10/Tipe 10 (5).webp'


const Armont10images =[
Armont101,Armont102,Armont103,Armont104,Armont105
]

export default Armont10images;